import type { FarePriceBreakdown } from "@b2bportal/air-shopping-api";
import type { HtsAirCfarOffersGroup } from "@b2bportal/core-types";
import type { AsyncThunk } from "@reduxjs/toolkit";

export interface FetchHtsAirCfarOffersRequest {
  tripId: string;
  fareId: string;
  passengers: Record<string, number>;
  farePriceBreakdown?: FarePriceBreakdown;
  /**
   * The shopping funnel ID for offer↔booking attribution. Omitted when no air
   * funnel is active, in which case the backend falls back to the
   * authenticated session ID.
   */
  funnelId?: string;
}

/**
 * The action type prefix that must be used when creating the HTS Air CFAR thunk.
 * This ensures the slice's extraReducers can match the thunk actions.
 *
 * @example
 * ```ts
 * const fetchHtsAirCfarOffersThunk = createAsyncThunk<
 *   HtsAirCfarOffersGroup[],
 *   FetchHtsAirCfarOffersRequest
 * >(HTS_AIR_CFAR_THUNK_PREFIX, async (request) => {
 *   // your fetch logic here
 * });
 * ```
 */
export const HTS_AIR_CFAR_THUNK_PREFIX = "htsAirCfar/fetchOffers";

export type FetchHtsAirCfarOffersThunk = AsyncThunk<
  HtsAirCfarOffersGroup[],
  FetchHtsAirCfarOffersRequest,
  object
>;
